import {
  Currency,
  CurrencyAmount,
  ETHER,
  Token,
  TokenAmount,
} from '@pancakeswap/sdk'
import { getWrappedNative } from 'config/constants/wrappedNative'

export function wrappedCurrency(
  currency: Currency | undefined,
  chainId: number | undefined,
): Token | undefined {
  return chainId && currency === ETHER
    ? getWrappedNative(chainId)
    : currency instanceof Token
    ? currency
    : undefined
}

export function wrappedCurrencyAmount(
  currencyAmount: CurrencyAmount | undefined,
  chainId: number | undefined,
): TokenAmount | undefined {
  const token =
    currencyAmount && chainId
      ? wrappedCurrency(currencyAmount.currency, chainId)
      : undefined

  return token && currencyAmount
    ? new TokenAmount(token, currencyAmount.raw)
    : undefined
}

export function unwrappedToken(token: Token): Currency {
  const wrappedNative = getWrappedNative(token.chainId)

  if (wrappedNative && token.equals(wrappedNative)) {
    return ETHER
  }

  return token
}
